import { Stack, Divider } from "@mui/material";
import { IconEyeLine } from "src/components/icons-mui/eye-line";
import { Button } from "src/components-mui/base/button/button";
import { Typography } from "src/components-mui/base/typography/typography";
import { CBHeaderNotInvestible } from "src/components-mui/pages/detail/certificate-box/components/header/header-not-investible";
import { InfoBox } from "src/components-mui/pages/detail/certificate-box/components/info-box";
import { CBPrices } from "src/components-mui/pages/detail/certificate-box/components/prices";
import { CBRatioTabBar } from "src/components-mui/pages/detail/certificate-box/components/ratio-tab-bar";
import { SpacedContainer } from "src/components-mui/pages/detail/certificate-box/components/spaced-container";
import { CBCertificateFee, CBPerformanceFee } from "src/components-mui/pages/detail/certificate-box/components/statistics";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";
import { useUserStore } from "src/stores/user-store";
import { EnumWikifolioStatus } from "src/types/common-enum";

const PUBLISH_BUTTON_TEST_ID = "publish-button";

export const CertificateBoxTest = () => {
    const userStore = useUserStore();
    const { dict, data } = useCertificateBoxContext();
    const isPublishRequested = data.wikifolio.status === EnumWikifolioStatus.PublishingRequested;

    return (
        <>
            <CBHeaderNotInvestible tooltip={data.tooltips.previewMode} />
            <SpacedContainer>
                {data.certificates.length > 1 && <CBRatioTabBar />}
                <CBPrices />
                <Divider />

                <Stack spacing={1}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                </Stack>
                <Divider />

                <InfoBox icon={<IconEyeLine sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography
                        sx={{
                            fontSize: "sm",
                        }}
                    >
                        {dict.testMessage}
                    </Typography>
                </InfoBox>
                {userStore.isCurrentUser(data.trader) && (
                    <Button
                        {...(isPublishRequested ? {} : { component: "a", href: data.editLink })}
                        disabled={isPublishRequested}
                        variant="contained"
                        size="medium"
                        color="green"
                        data-test-id={PUBLISH_BUTTON_TEST_ID}
                    >
                        {dict.publishButton}
                    </Button>
                )}
            </SpacedContainer>
        </>
    );
};
